<template>
    <div class="toast">
        <div @click="closeAppLinkToast" style="position: absolute; top: 0; right: 0; width: 26px; height: 25px; text-align: center;">
            <div style="padding-top: 2px;">
                <img style="width: 7px;" :src="require('@/assets/img/toast_x_btn.png')" alt="">
            </div>
        </div>
        <div style="text-align: center;">
            <div style="font-weight: 400; font-size: 11px; line-height: 20px;">앱에 접속하면 더욱 편하게 서비스를 사용하실 수 있어요</div>
            <div @click="showInApp" style="font-weight: 700; font-size: 14px; line-height: 24px; color: #4b8aff;">앱에서 계속하기</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppLinkToast',
    props: {

    },
    data() {
        return {

        }
    },
    methods: {
        closeAppLinkToast() {
            sessionStorage.setItem('IS_SHOW_NOW_DETAIL_APPLINK_POP', true);
            this.$GlobalStore.setIsShowAppLinkToast(false)
        },
        showInApp() {
            let schemes = this.$GlobalStore.schemes();
            let schemes_str = 'action=' + schemes.action;
            if(schemes.param0) schemes_str += '&param0=' + schemes.param0;
            if(schemes.param1) schemes_str += '&param1=' + schemes.param1;
            if(schemes.param2) schemes_str += '&param2=' + schemes.param2;

            console.log(schemes_str);
            // alert(schemes_str);
            const userAgent = navigator.userAgent;

            if (userAgent.match(/android/i)) {
                location.href = `intent://action?${schemes_str}#Intent;scheme=obyungearuser;package=com.ubiplus.custom.obyungear_user;end`
            } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
                const visitedAt = (new Date()).getTime(); // 방문 시간
                setTimeout(function() {
                    if ((new Date()).getTime() - visitedAt < 2000) {
                        location.href = 'itms-apps://itunes.apple.com/app/id6443870201';
                    }
                }, 500);
                setTimeout(function() {
                    location.href = `obyungearuser://?${schemes_str}`;
                }, 0);
            }
        },
    },
}
</script>

<style scoped>
.toast {
    position: fixed;
    z-index: 9999;
    bottom: 76px;
    width: calc(100% - 24px);
    left: 50%;
    transform: translateX(-50%);
    height: 76px;
    border-radius: 12px;
    backdrop-filter: blur(20px);
    background: #F5F5F5E5;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
